import { useEffect } from 'react';

import { getIsPieChartIntroductionSkipped } from '../../../../../db/polls';

export interface UseIntroduction {
  goToNextStep: () => void;
}

const useIntroduction = ({ goToNextStep }: UseIntroduction) => {
  useEffect(() => {
    const skipIntroduction: boolean = getIsPieChartIntroductionSkipped();

    if (!skipIntroduction) return;

    goToNextStep();
  }, []);
};

export default useIntroduction;
